import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { pageStyles } from "../../../theme";

export const useStyles = makeStyles((theme: Theme) => ({
  ...pageStyles(theme),
  root: {},
  divider: {
    width: "15rem",
    borderTop: "1px solid #fff",
    margin: "2rem 0",
  },
  text: {
    maxWidth: theme.spacing(90),
    fontSize: 20,
    lineHeight: 1.2,
  },
  main: {
    padding: "6rem",
    backgroundColor: "#2b2b2b",
  },
  mainTopSection: {
    borderBottom: "2px solid #fff",
    paddingBottom: "3rem",
  },
  sectionContainer: {
    padding: "1rem 0rem 1rem",
  },
  selectsContainer: {
    padding: "3rem 0",
    display: "flex",
    justifyContent: "flex-end",
    gap: "1.25rem",
  },
  sectionFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  bottomSectionInner: {
    padding: "1.5rem 2rem",
    marginTop: "6rem",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  bottomSectionText: {
    marginTop: "1rem",
    fontSize: 18,
    lineHeight: 1.2,
  },
  bottomSectionLink: {
    marginTop: "3rem",
    fontSize: 16,
    lineHeight: 1.2,
    fontWeight: 600,
    color: "#fff",
  },
}));
